/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const PenTool = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "m12 19 7-7 3 3-7 7-3-3z" }],
    ["path", { d: "m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" }],
    ["path", { d: "m2 2 7.586 7.586" }],
    ["circle", { cx: "11", cy: "11", r: "2" }]
  ]
];

export { PenTool as default };
//# sourceMappingURL=pen-tool.js.map
